<div
  [ngStyle]="{ maxHeight: containerHeight }"
  id="transaction-list"
  class="transaction-card w-100"
  (scroll)="onScroll($event)"
>
  <div
    [class.is-left]="!templateContainsIcons"
    [class.global-list-styling]="isGlobalStylingEnabled"
    *ngFor="let transaction of transactionData; let first = first; let last = last; let index = index"
    [ngStyle]="{ height: 100 / transactionData.length + '%' }"
  >
    <div
      *ngIf="imageEnabled && !templateContainsIcons"
      [ngStyle]="{
        'margin-top': symbolCreditDebitMargin.marginTop + symbolCreditDebitMargin.marginUnit,
        'margin-bottom': symbolCreditDebitMargin.marginBottom + symbolCreditDebitMargin.marginUnit,
        'margin-left': symbolCreditDebitMargin.marginLeft + symbolCreditDebitMargin.marginUnit,
        'margin-right': symbolCreditDebitMargin.marginRight + symbolCreditDebitMargin.marginUnit,
      }"
    >
      <mat-icon *ngIf="transaction.transactionType === 'credit'" svgIcon="credit-symbol"></mat-icon>
      <mat-icon *ngIf="transaction.transactionType === 'debit'" svgIcon="debit-symbol"></mat-icon>
    </div>
    <finxone-web-frontend-list-item
      class="w-100"
      [customHandlebarModel]="buildTransactionHandlebarModel(transaction, first, last, index)"
      [content]="transactionTemplate"
      (itemClicked)="onClickRow(transaction)"
      (actionTriggered)="onActionTriggered($event, transaction)"
      [customClass]="'d-contents'"
      [gestures]="widgetAttributes.widgetProperties?.gestures"
      [listActions]="widgetAttributes?.listActions"
    ></finxone-web-frontend-list-item>
  </div>
</div>
